module.exports = __webpack_public_path__ + "img/seminar.93491eba.svg";